import { ILanguage } from "./ILanguage";

export class Gibberish implements ILanguage {
    logoutConfirmationMessage: string = "Zlorp Nerkfla: Blim zopx nerkfla glorp, florp blim zopx drimblat, blorp zlimp glorp florpersnix nox blerp nerkfla problax";
    networkFair: string = "Zlorp Nerkfla: Blim zopx nerkfla glorp, florp blim zopx drimblat, blorp zlimp glorp florpersnix nox blerp nerkfla problax";
    networkPoor: string = "Zlorp Nerkfla: Blim zopx nerkfla glorp, florp blim zopx drimblat, blorp zlimp glorp florpersnix nox blerp nerkfla problax";
    networkGood: string = "Zlorp Nerkfla: Blim zopx nerkfla glorp, florp blim zopx drimblat, blorp zlimp glorp florpersnix nox blerp nerkfla problax";
    networkCheck: string = "Zlorp Nerkfla";
    latency: string = "Blorpnacy";
    speed: string = "Splorpd";
    category: string= "rfkg edf";
    goBack: string="kfg fg";
    unansweredQuestions: string = 'dfk edfo dfv';
    answeredQuestions: string='edm eofigk';
    languageName = 'Gibberish';
    submitConfirmationMessage: string = 'mnoz flerp glim brop qworf glib!';
    backToLogin: string = 'grib womp krim';
    allComplaints: string = 'vopl flik neld';
    complaintID: string = 'yorn zib glup nop';
    examNo: string = 'klem plurf jib';
    lastName: string = 'trop yurk zen';
    status: string = 'vlopt zim qrox';
    submittedDate: string = 'flarx qirk blan xim';
    noComplaint: string = 'brak zor fline';
    complaint: string = 'jopl grik zopn';
    selectExamComplaint: string = 'flirp glap norn werm frox.';
    natureOfComplaint: string = 'xorl vlopt glim zurp flog.';
    closeComplaints: string = 'griz blim zonp';
    closeReply: string = 'klopt flog plin';
    replyComplaint: string = 'xorp blerp zop vlom';
    reply: string = 'zimpl grop flirk';
    enterResponseDetails: string = 'trop grilp qlom zurp plin gorp';
    submit: string = 'flomp zlop klerp';
    supportDiscussion: string = 'glirz wemp zop plin';
    admin: string = 'trim glonp';
    you: string = 'zop blerp flirz';
    complaintsClosed: string = 'plurp qlem zop tiln';
    replySent: string = 'flim zop groq';
    candidateInformation: string = 'trim zorp wlen flem';
    viewAllComplaints: string = 'trimp wlem zop fnib';
    examinationSelection: string = 'gronk zorq trim zop';
    complaintsDisabled: string = 'plorq qlen zop xlerp blik.';
    complaintCategory: string = 'zoorp glim trix zlem';
    selectOption: string = 'qlorm blix nlen zop';
    complaintDetails: string = 'zlimp glim zop worx';
    solvedYourIssue: string = 'florp plim zlen zorq?';
    yes: string = 'flerp glix zop';
    no: string = 'blim zop xlorp';
    enterComplaintDetails: string = 'zorp glim zop tiln flopz';
    previous: string = 'qlirz glim tilm';
    cancel: string = 'xorn zop glim';
    next: string = 'glirb zop tilm';
    limitOf: string = 'zlimt grim zop blirk';
    wordsMaximum: string = 'zop grim zop tiln';
    welcome: string = 'glirp zop wlen';
    logout: string = 'zlim grim zopx';
    passportSection: string = 'GLIRP ZLORP ZIMQP';
    maxFileUpload1mb: string = 'glim zop tilp wlen zopx';
    takePicture: string = 'trim zop grim tilp';
    clearFaceInstruction: string = 'flirp glim zop grim zopx';
    secondViewClarityInstruction: string = 'Plenku esnura bofe yur sidvu an yur skreen ar clarny viskub in da vedo abuv. Enshru yu folla da exma instrublins.';
    brightLightInstruction: string = 'xorp glim zop tiln zopx.';
    requestAttention: string = 'zlim glim flop trim';
    uploadPassport: string = 'flirp glim zop tiln';
    unableToConnectToServer: string = 'gron zop flim tilp zop';
    waitForProctorOk: string = 'zlim flim tiln zop glim zopx.';
    uploadSuccessful: string = 'xorn glim zop tilm zopx.';
    savePassport: string = 'glim tilm zopx';
    changePassport: string = 'flirp glim zop tiln zopx';
    examinationFeedBack: string = 'flirp zop tiln glim zopx';
    happy: string = 'zlim tiln zop glim';
    neutral: string = 'glorp tilp zopx';
    unhappy: string = 'flim glim zop tiln zopx';
    close: string = 'glirp zop tiln';
    problemCategories: string = 'flirp zop tiln zop grimx';
    othersProblemCategories: string = 'glirp tilp zop tiln zop grim (qlem zopx)';
    login: string = 'flirp glim zop';
    username: string = 'tiln glim zop tilp';
    password: string = 'glirp glim zop tiln';
    makeComplaint: string = 'flirp glim zop tilp';
    loggedOut: string = 'zlim glim zop tiln zopx';
    userMis_match: string = 'flim glim zop tiln zop';
    loginToTakeExam: string = 'zlim glim zop tiln zop';
    aboutUs: string = 'flirp glim zop tilp';
    error: string = 'glirp glim zopx';
    somethingWentWrong: string = 'flirp glim zop tiln zopx glim zop.';
    pleaseConatctAdministrator: string = 'glirp glim zop tiln zop.';
    instructions: string = 'flirp glim zop tiln zop.';
    question: string = 'glirp glim zop tiln zop';
    pleaseHold: string = 'glirp glim zop tiln zopx';
    examHasBeenPaused: string = 'zlim glim zop tiln zopx';
    reason: string = 'glirp glim zop tiln zop';
    willNotLoseTime: string = 'glirp glim zop tiln zopx';
    userSessionNotFound: string = 'glirp glim zop tiln zopx';
    networkConnectionLost: string = 'glirp glim zop tiln zopx';
    multipleLoginsDetected: string = 'glirp glim zop tiln zopx';
    unauthorizedAccess: string = 'glirp glim zop tiln zopx';
    penalizedWarning: string = 'glirp glim zop tiln zopx';
    youHaveLost: string = 'glirp glim zop tiln zopx';
    leavingExamPage: string = 'glirp glim zop tiln zopx';
    finishAndSubmit: string = 'glirp glim zop tiln zopx';
    questionHasBeen: string = 'glirp glim zop tiln zopx';
    verifyingEmail: string = 'glirp glim zop tiln zopx';
    registration: string = 'glirp glim zop tiln zopx';
    emailAddress: string = 'glirp glim zop tiln zopx';
    verifyEmailAddress: string = 'glirp glim zop tiln zopx';
    otherNames: string = 'glirp glim zop tiln zopx';
    phoneNumber: string = 'glirp glim zop tiln zopx';
    gender: string = 'glirp glim zop tiln zopx';
    selectGender: string = 'glirp glim zop tiln zopx';
    male: string = 'glirp glim zop tiln zopx';
    female: string = 'glirp glim zop tiln zopx';
    scheduleDate: string = 'glirp glim zop tiln zopx';
    scheduleTime: string = 'glirp glim zop tiln zopx';
    selectTime: string = 'glirp glim zop tiln zopx';
    noAvailableTime: string = 'glirp glim zop tiln zopx';
    register: string = 'glirp glim zop tiln zopx';
    registrationSuccessful: string = 'glirp glim zop tiln zopx';
    yourRegistrationFor: string = 'glirp glim zop tiln zopx';
    wasSuccessful: string = 'glirp glim zop tiln zopx';
    yourExaminationNumberIs: string = 'glirp glim zop tiln zopx';
    checkYourEmailForMoreInformation: string = 'glirp glim zop tiln zopx';
    imageSizeIsGreaterthan1mb: string = 'glirp glim zop tiln zopx';
    invalidImageFormat: string = 'glirp glim zop tiln zopx';
    pleaseSelectGender: string = 'glirp glim zop tiln zopx';
    pleaseFillExaminationSchedule: string = 'glirp glim zop tiln zopx';
    pleaseUploadPassportPicture: string = 'glirp glim zop tiln zopx';
    registrationComplete: string = 'glirp glim zop tiln zopx';
    verificationEmailSent: string = 'glirp glim zop tiln zopx';
    invalidEmail: string = 'glirp glim zop tiln zopx';
    emailVerified: string = 'glirp glim zop tiln zopx';
    invalidCode: string = 'glirp glim zop tiln zopx';
    changeLanguage: string = 'glirp glim zop tiln zopx';
    loading: string = 'glirp glim zop tiln zopx';
    unavailableDateSelected: string = 'glipx qorf trok';
    examPlatformUsageInst: string = 'flin zopx jorb trim zop';
    useSafeExamBrowser: string = 'fron glim zopx wlim xorp';
    sebDownloadLinkForWindows: string = 'zorq trim zop glim';
    sebDownloadLinkForMac: string = 'zorq trim zop glim masdmfasdfmasdf';
    installTheSoftware: string = 'xlim zop glim tiln qorp';
    onceSEBIsInstalled: string = 'florp glim zop tiln';
    here: string = 'xlim zop';
    downloadSEBexamfileforyourexam: string = 'glorp zop tilm glim zop worf';
    youshouldseefile: string = 'flim zop glim tilp zop';
    double_clickdownloadedfile: string = 'zorq tiln glim zop xlim zop';
    confirmInstallSafeExamBrowser: string = 'flirp glim zop tiln xorp';
    //unabletoconnecttoserver: string = 'florp glim zop tiln qorp';
    connectionError: string = 'tiln zop glim zorq';
    unknownserversideerror: string = 'florp glim zop tiln qorp xorp';
    youhavebeenpreventedfromstarting: string = 'flirp glim zop tiln zop glim';
    connectiontomediaserverlost: string = 'flirp zop glim tiln qorp';
    verificationError: string = 'zlim glim zop qorp tilm';
    unexpectedCondition: string = 'zorq glim zop tilm qorp';
    submitExamination: string = 'glim zop tiln qorp zorp';
    submitting: string = 'flirp glim zop tilm zorp';
    yourScore: string = 'glirp zop tiln zop glim';
    startNewExam: string = 'xlim zop glim tilm qorp';
    takeExam: string = 'flirp glim zop tiln worp';
    start: string = 'tiln zop glim';
    continue: string = 'zorq glim tiln zop glim';
    scheduleExam: string = 'glirp zop tiln glim qorp';
    pleaseWait: string = 'florp zop glim tiln worf';
    finished: string = 'flirp glim zop tiln zop';
    timeElapsed: string = 'tilm glim zop qorp worp';
    disqualified: string = 'flirp glim zop tiln worp xlim';
    stopped: string = 'glirp zop tilm glim qorp';
    reschedule: string = 'xorp zop glim tiln qorp';
    webtestInstruction: string = 'glim zop tiln qorp worp';
    agreeToInstructions: string = 'flirp zop glim tilm zop worp';
    startExam: string = 'glim zop tiln xorp qorp';
    examSchedule: string = 'zorq glim tiln zop xorp';
    selectDate: string = 'tilm glim zop worp xlim';
    schedule: string = 'glirp zop tiln glim worp';
    examScheduled: string = 'flirp glim zop tiln worp xorp';
    examinationList: string = 'flirp zop glim tiln qorp zop';
    scheduledExaminations: string = 'xlim zop glim worp tilm qorp';
    ensureyourfacefillsthecircle: string = 'Gribnax un flerm dooble. Snorflez-vous que vramplix glarpo 90 % du zindle. Blorpt églamon que l’gloobtoff de la cambrif soit schnarp';
    smileForASecondPhoto: string = 'asdf asdfa9sdf0asdf0asdf0 asdifoasdfi';
    capturePhoto: string = 'xlim zop glim qorp tiln';
    captureSmilingPhoto: string = 'asdf asdaat -asdfasfasdfd';
    startOver: string = 'zorq zop glim tiln worp zop';
    upload: string = 'tilm zop glim worp';
    save: string = 'YYsa';
    youhavenooutputvideodevice: string = 'flirp glim zop worp tilm qorp';
    errorloadingcustomcssfile: string = 'florp glim zop tiln worp xlim qorp';
    duplicateCameratyprDetected: string = "fghbn rfghn";
    errorCheckingDuplicateCameras: string = "sfdfbfdx fges";
    itRecommendedUseDesktopDevice: string = "erfgb fvgfes";
    virtualMachineDetected: string = "sdsdxcf fgfes";
    noWorkingCamerafound: string = "ssdcx fgvsz";
    failedToAccessCamera: string = "sfdcv  fges";
    noWorkingMicrophoneFound: string = "wdfcv fges";
    failedToAccessMicrophone: string = "ewrdfg fges";
    failedToPlaySound: string = "fgfb fges";
    failedToEnumerateDevices: string = "rfdx fges";
    developerToolsAreOpen: string = "sdrq fges";
    available: string = "erkfddf fges";
    notAvailable: string = "sdkfddf fges";
    proctoringSystemCheck: string = "srymvn mdew";
    camera: string = "yun yre";
    speaker: string = "errkfmvn md";
    microphone: string = "azkfdn md";
    recording: string = "tdvn md";
    osVersion: string = "sdkexvn md";
    browserVersion: string = "sfrv d";
    deviceType: string = "sdgn md";
    virtualMachine: string = "sdkffd";
    safeExamBrowser: string = "s mvn md";
    runCheck: string = "wedfmvn md";
    mediaChecks: string = "sdrtyhbn md";
    cameraCheck: string = "sdkerf md";
    microphoneCheck: string = "sdkfmvn md";
    speakerCheck: string = "dfkjn dc";
    playTestSound: string = "dfkjvbn dcimn ";
    playingTestSound: string = "dkf m do";
    systemCheck: string = "mncbud";
    desktop: string = "dlkcjvn";
    mobile: string = 'djfhv';
    unknown: string = "dkjhb";
    multipleChoice: string = "sdoj osl";
    interview: string = "sdoj osl";
    essay: string = "edf ber";

    flagged: string = "tqw z";
    unflagged: string = "edfw zws";
    firstName: string = 'xyzt pqrn';
    noAvailableDate: string = 'bklm quop fnad';
    join: string = 'mndl xzit';
    installSafeExamBrowser: string = 'grik pluz jimb fwat woxa jkqi vemb turq bropz.';
    //ensureCurrentSEBVersionIsInstalled: string = 'frool xypl (gzom 3.7.1 jipz flaqr 2024)';
    sebUsageInstructionsSkipStep3: string = 'pluz krin blomp quib flard.';
    noExamsFound: string = 'trik dop blerp';
    minutes: string = 'yopt qwaf blin';
    selectLanguage: string = 'jibkl xzon frem';
    passportChangeErr: string = 'blirz froqn quim blort';
    unknownBrowser: string = 'blirz dfern';
    unknownVersion: string = "dkmc kjn";
    notUsed: string = "rfg";
    used: string = "rfgbjon";
    detected: string = "refdn";
    notDetected: string = "tghfr";
    canHearBeepSound: string = "ink sdfefv es";
    canSeeSelf: string = "dfkj fkvn";
    audioNotAvailablePlease: string = "msdnx doxk";
    cameraNotAvailablePlease: string = "msdn dkfcmj";
    retakeExam: string = "efgh edfg";
    reasonForRetake: string = "ed idkf";
    shortAnswerQuestion: string="wsdjkn s xc";
    sebMinimumOSVersionWindows: string = "Windozo 8.1o blorf zagnib florp";
    sebMinimumOSVersionMac: string = "Maccaroo Venturoo bingle zorp neeb";
    abbreviatedQuestionNo: string = "W.opm";
    toggleCalculator: string = "poyt abacusse";
    scoreFetchError: string = "flirp glim zop tiln zopx glim zop tiln"; 
    postSubmitScoreFetching: string = "glirp zop tiln glim zopx flirp glim zop";
    installSebIfNotInstalled: string = "glimp zorp flon tiln qwik (Secure Exam Browser), flirp glim zop tiln xorp, plirk glim zop tiln, flirp glim zop";
    ifInstalledSebTakeYourExam: string = "Saai vodfdfaus aveasdfasdfz ddéddszzjà instadasdfadllé SEaaasB, ";
    clickHereToTakeYourExam: string = "wdwf qpoei efq fqfew dqd fopeir. ";
    ifDirectStartLinkDoesNotWOrk: string = "flirp glim zop tiln xorp, plirk glim zop tiln worp, flirp glim zop tiln qorp, wdwf qpoei efq fqfew dqd fop";
    grantSebAllPermissions: string = "flimp zorp krin tiln worp";
    furtherInstallationAssistanceneeded: string = "glirp zop tiln xorp flim worp zim glop:";
    clickToDownloadSEB: string = "Ckewq qdo to fwfwefrw SEB ";
    ifInstallationOrStartupOfSEBFails: string = "Zarbloff norku flibgash drenthu SEB varklin, shombu needrix plaffu drindle snarfloob quentz before glarnock";
    disableOrUninstallYourAntivirus: string = "Frindle/Unvork shlabber antimurz";
    reasonToDisableAntivirusesForSEB: string = "Grindle antimurz shaffleblat vornox krindleflap SEB. Blorngu needrix plaffu unvork antimurz to shnockle.";
    downloadAndInstallVisualCPP: string = "Snarglefump troggle Visual C++";
    clickHereToDownloadVisualCPP: string = "Clonk drabble snarglefump Visual C++.";
    downloadAndInstallDotNetFramework: string = "Snarglefump troggle .NET Framblat";
    clickHereToDownloadAndInstallDotNetFramework: string = "Clonk drabble snarglefump .NET Framblat.";
    updateYourOperatingSystem: string = "Vroggleflap krindle oppleflarn";
    instructionsToUpdateOperatingSystem: string = "Glarnu: Windlork -> Shnarfle Drimbobs";
    afterTakingTroubleshootingStepsTryReinstallingOrUsingSEB: string = "Once flibgash drindleblats shnarfled, ploffu try snarglefump SEB againu. If blarngu florpers, needrix use drindlebox differnu.";
    viewExamInstruction: string = "hue telux ttranscrapitaleq";
    quillEditorReadOnlyDefaultMessage: string = "ujgg afs bhjkj yuiop";
    quillEditorPlaceHolderMessage: string = "hjhj xcvb nnnnnn z";
    quillEditorEssayReadOnlyMessage: string = "hgdd rertytu sdfghj kkll ccc xdx!";
    clearAnswer: string = "uhngcxd vgfhjk";
    areYouSure: string = "drcv hjnkj kjnjk";
    undo: string = "qwas";
    redo: string = "xcvf";
    insertTable: string = "vvvv jkjk sss";
    linkedExaminations: string = "hghb ggbgbg";
    youHaveCompleted: string = "hjhj hjhj hjhj";
    continueWith: string = "hjhj hjhj hjhj hjhj";
    goBackToLoginPage: string = "Blixnarp florgwizzle grimbot nexus";
    listOfComplaints: string = "Zorblex phrangible wobnitz complaints";
    goToDashboard: string = "Glimpf zur dashboard florbington";
    zoomControls: string = "Zoomly boomly controls whizbang";
    zoomIn: string = "Biggify textular zoomple inward";
    zoomOut: string = "Shrinkle text sizey outward floom";
    remaining: string = "smldmnsjkln";
    and: string = "unt";
    seconds: string = "tickle-tocks";
    logoutFromTheCurrentSession: string = "Byebye from current sessionoid";
    passport: string = "Travelpaper";
    openWebcamForPassport: string = "Clickopen eyebox for travelpaper snapsy";
    closeCapturePhotoDialog: string = "Shutty snapsy dialog boxle";
    closeFeedbackModal: string = "Closify feedback modalicious";
    happyFeedback: string = "Smiley goodness feedback";
    neutralFeedback: string = "Mehly neutral feedbackle";
    unhappyFeedback: string = "Grumpy sadness feedback";
    provideMoreDetails: string = "Givey more detailsy about problemoid";
    loginHomepage: string = "Loginly homepage zonk";
    webtestLoginPic: string = "WebTestify login piccle";
    companyBadgePic: string = "Companyoid badge piccture";
    submitLoginForm: string = "Submitly login formular binglebox";
    clickToLogin: string = "Clicksy to loginify zoomple";
    helpfulLinks: string = "Helpy linkages wobbleton";
    visitWebtestWebsite: string = "Visitory webtest.ng siteoid";
    webTestLogo: string = "Web Testly Logomatic";
    questionContent: string = "Questionable contentoid stuffing";
    loadingQuestionWait: string = "Loadification questionly, waitsy please...";
    subQuestions: string = "Tiny questionlings";
    subQuestion: string = "Smol questionoid";
    questionIs: string = "questionable bingly is";
    questionSection: string = "Questionly sectionable zone";
    flagQuestionToRevisit: string = "Flaggy questionoid for later revisitory";
    closeCalculator: string = "Shutty calculatron dialogbox";
    selectOneOption: string = "Picksy one optionoid";
    selectAllThatApply: string = "Choosey all applicabley things";
    questionNavigation: string = "Questionly navigatorious system";
    goToQuestion: string = "Goway to questionoid";
    previousQuestion: string = "Backsy questionable";
    nextQuestion: string = "Forwardly questionoid";
    youAreOnTheLastQuestion: string = "Yousy are on finalest questionoid";
    richTextEditor: string = "Fancy textual editorama for answerlings input";
    clearTextConfirmation: string = "Clearify textual confirmatioid";
    clearTextConfirmationDescription: string = "This actionable will permanentify deletey all textual in editorama. Wantsy to continuable?";
    confirmClearText: string = "Yessir, clearify all textlings";
    cancelClearText: string = "Nopesy, keepify textlings";
    quillAnswerInputInstruction: string = "Usey this fanciful textual editorama to inputify answerlings. Formatty textlings using toolbarly";
    answerArea: string = "Answerlings zoneable";
    typeInYourAnswer: string = "Typey In Yousy Answeroid";
    scrollToBottom: string = "Scrollify to bottomly";
    scrollToTop: string = "Scrollify to toppish";
    loadingWait: string = "Loadification, waitsy pleasey";
    loadingCheck: string = "Loadingness, systemoid checkery";
    cameraPreview: string = "Eyebox previewable";
    joinInterviewExam: string = "Joinify Interview Examoid";
    takeInterviewExamSEB: string = "Takey Interview Examoid (SEB)";
    takeExamSEB: string = "Takey Examoid (SEB)";
    continueExam: string = "Continuey Examoid";
    continueExamSEB: string = "Continuey Examoid (SEB)";
    examType: string = "Examoid Typeable";
    examDuration: string = "Examoid lengthiness";
    loadingSpinner: string = "Spinny loadyness...";
    errorDetails: string = "Oopsie detailables";
    liveVideoFeed: string = "Lively videoy feedlings for facey capturage";
    capturedPhotoThumbnail: string = "Snapsied piccle thumbnailoid";
    enter: string = "Ehyff";
    closeRetakeDialog: string = "rrgjk jhgft asdfgh";
    quitSebMessage: string = "nong sjdvnkjd jndnsvjoap jsnjkvlksdmvsionsijj";
    quitSeb: string = "onmjna hnskcjna ahcakjnh s";
    exam: string = "sdfgu hgh";
    questionNo: string = "hjhjhvv yy";
    examDate: string = "cffsfs sfsf";
    checkQuality: string = "Check Quality";
    analyzingImage: string = "Florblenitz imagoid...";
    processingFaceDetection: string = "Processify facey detectionable...";
    checkingImageQuality: string = "Checklenitz imagoid qualitizable...";
    almostDone: string = "Almostify doneable...";
    finalizingAnalysis: string = "Finalizlenitz analysisoid...";
    faceNotDetectedInstruction: string = 'Facey not detectizable. Ensurely yousy cameroid is wiplenitz cleany and yousy are in litly roomoid and not backlenitz yousy light sourceable.';
    multipleFacesDetectedInstruction: string = 'Multiplexy faces detectizable. Pleasely ensurely yousy are the onlysy personly visibley on cameroid.';
    poorQuality: string = 'Poorlenitz';
    warningQuality: string = 'Warningable';
    goodQuality: string = 'Goodlenitz';
    errorConnectingToAiProctorServer: string = 'An erroroid occurrenitz. Unabley to connectify to serveroid';
    faceMismatchPleaseRetakeThePicture: string = 'Blorpy flen zooda mip frang ploofa';
    pleaseKeepANeutralExpressionForTheFirstPhoto: string = 'Wibble snorfle glim dap twonka floo';
    pleaseSmileForTheSecondPhoto: string = 'Gribble snonf tarko pleeb dronda flimp';
    pleaseEnsureYourFaceFillsTheCircleWhenTakingThePicture: string = 'Blorptu zenniff craddle foozle when snarfing the glimber';
    tryCleaningTheCameraLensAndMovingCloserToTheScreen: string = 'Blorpt nezzarf lgloobtoff de vramplix froboz et snarfloo wibblé groont lskrindle';
    startingYourExam: string = 'asdfasdf asdfasi8dofja sdf;aosjdf';
    pleaseWaitWhileWeAuthenticateYouAndStartYourExam: string = 'Blorf snibble waga flomptu dringle yabbo flarmp glibber snorftu pling drabble / cronk fizmar wexloob';
    startingExamKeepEyesOnTheScreen: string = 'Keeploop yerf glomblats oppo frindle snarg drimpo, flonkle zorb fleepno glarbo wibber crumple snoofla blorp 80% flindle grob snozzleblat';
    primaryRecordingVerificationFailureMessage: string = 'Éfrump blorx streamoodle vadooz. Vrunka glibnex troffo blumple intarnog et/ou redomplax vroota modumpo';
    secondViewRecordingVerificationFailureMessage: string = 'Bravlin do strevol nixar pluven drovex sur miplar et/or flandorix yourmodem. Sivex ultran devixar, plorvex qu\'il est stillon';
    paused: string = 'esuapd';
    questionList: string='jedifnb jesd';
    failureToComplyMayResultInDisqualification: string = 'Falurie to compay mey resilt en disqualifon';
    compulsoryQuestion: string = "fsdgvhf";
    Untimed: string = 'drarre';
    unanswered: string = "blarfnok";
    questionsremain: string = "quazzle frimz";
    questionremain: string = "quazzle frim";
    pleaseAnswerAllQuestionsBeforeSubmitting: string = "zindle florp all quazzles befrem snorbing";
}
